var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings',{attrs:{"submitting":_vm.submitting,"dirty":_vm.hasChanges,"divider":""},on:{"submit":_vm.submit}},[_c('bar-chart-widget-form',{attrs:{"with-filters":_vm.hasAccessToFilter,"with-periodic-refresh":"","with-preset":""},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }